import React from 'react';
import classNames from 'classnames';

/* Components */
import { InputField } from 'ht-styleguide';
import { WarningHintIcon } from '@components/UI/Messages';

/* Styles */
import styles from './prequestioncheckbox.module.scss';
import { Question } from 'types/sku.types';

/* Types */
type PreQuestionInputProps = {
  question: Question;
  error?: string;
  value: string;
  onChange: BaseAnyFunction;
};

const PreQuestionInput = (props: PreQuestionInputProps) => {
  const { question, value, onChange, error } = props;

  /* Styles */
  const hintIconStyles = classNames(styles.answerHintIcon, styles.answerHintIconInput);

  return (
    <div key={question.id}>
      <div className={styles.answer}>
        <InputField label={question.textDirect} type="text" value={value} onChange={onChange} error={error} />
        <WarningHintIcon content={question.hint} hintIconStyles={hintIconStyles} />
      </div>
    </div>
  );
};

export default React.memo(PreQuestionInput);
